import request from '@/utils/request'

//新增主题帖子
export function addPost(data) {
	return request({
		url: '/client/api/addMain',
		method: 'post',
		data
	})
}
//查看帖子详情
export function postByid(data) {
	return request({
		url: '/client/api/getById',
		method: 'get',
		params: data
	})
}
//添加一次 查看次数
export function postWatch(data) {
	return request({
		url: '/client/api',
		method: 'get',
		params: data
	})
}
//评论帖子
export function addCommment(data) {
	return request({
		url: '/client/api/addCommment',
		method: 'post',
		data
	})
}
//回复评论
export function addreply(data) {
	return request({
		url: '/client/api/addreply',
		method: 'post',
		data
	})
}
//查看帖子回复
export function getchild(data) {
	return request({
		url: '/client/api/getchild',
		method: 'get',
		params: data
	})
}
//个人中心我的帖子
export function getMyTopic(data) {
	return request({
		url: '/client/api/getMyTopic',
		method: 'get',
		params: data
	})
}
//删除帖子
export function deltopic(data) {
	return request({
		url: '/client/api/deltopic',
		method: 'delete',
		params: data
	})
}
//个人中心我的回复 + 我的评论
export function getMyAnswer(data) {
	return request({
		url: '/client/api/getMyAnswer',
		method: 'get',
		params: data
	})
}
//删除评论
export function delcomment(data) {
	return request({
		url: '/client/api/delcomment',
		method: 'delete',
		params: data
	})
}

//学生提问问题
export function addQuestion(data) {
	return request({
		url: '/client/api/addQuestion',
		method: 'post',
		data
	})
}
//学生查看自己的问题回复
export function getMyQuestion(data) {
	return request({
		url: '/client/api/getMyQuestion',
		method: 'get',
		params: data
	})
}
